"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tofcam660HDF5Image = void 0;
const hdf5 = __importStar(require("jsfive"));
const lzf = __importStar(require("lzfjs"));
const SensorImage_1 = require("./SensorImage");
const ndarray_1 = __importDefault(require("ndarray"));
const mill_sensor_M12B3713IRM12_lens_table_1 = require("./lens-tables/mill-sensor-M12B3713IRM12-lens-table");
hdf5.Filters.set(
// https://github.com/HDFGroup/hdf5_plugins/blob/master/docs/RegisteredFilterPlugins.md
32000, compressedData => lzf.decompress(compressedData).buffer);
class Tofcam660HDF5Image extends SensorImage_1.SensorImage {
    static NUM_CHANNELS = 2;
    static HEIGHT = 240;
    static WIDTH = 320;
    static VALID_DISTANCE_RANGE = [0, 64000]; // inclusive
    static VALID_AMPLITUDE_RANGE = [0, 2894]; // inclusive
    array;
    constructor(buffer) {
        const file = new hdf5.File(buffer);
        const dataEntry = file?.get('results')?.get('data_');
        if (!dataEntry) {
            throw new Error('Invalid data, can\'t find data entry');
        }
        const expectedShape = [Tofcam660HDF5Image.NUM_CHANNELS, Tofcam660HDF5Image.HEIGHT, Tofcam660HDF5Image.WIDTH];
        if (!dataEntry.shape) {
            throw new Error('Invalid data, can\'t find shape');
        }
        if (dataEntry.shape.length !== expectedShape.length) {
            throw new Error(`Invalid data, shape is not expected shape, expected [2, 240, 320], but got ${JSON.stringify(dataEntry.shape)})}`);
        }
        for (let i = 0; i < expectedShape.length; i++) {
            if (dataEntry.shape[i] !== expectedShape[i]) {
                throw new Error(`Invalid data, shape is not expected shape, expected [2, 240, 320], but got ${JSON.stringify(dataEntry.shape)})}`);
            }
        }
        if (dataEntry.dtype !== '<u2') {
            throw new Error('Invalid data, dtype is not unsigned 16-bit integer');
        }
        const array = (0, ndarray_1.default)(dataEntry.value, [Tofcam660HDF5Image.NUM_CHANNELS, Tofcam660HDF5Image.HEIGHT, Tofcam660HDF5Image.WIDTH]);
        super(Tofcam660HDF5Image.WIDTH, Tofcam660HDF5Image.HEIGHT, Tofcam660HDF5Image.computeStats(array));
        this.array = array;
    }
    fieldOfView() {
        return {
            xDegrees: 108 /* degrees */,
            yDegrees: 77 /* degrees */,
        };
    }
    pixelWidthOnSensorInMm() {
        return 0.02;
    }
    getRaw(x, y) {
        return Tofcam660HDF5Image.getRawFromArray(this.array, x, y);
    }
    asArray() {
        return this.array;
    }
    detectPartNumber() {
        return 'commercial-bins-poc-a';
    }
    pixelDepthToCameraCoordinates(pixelX, pixelY, depth) {
        return this.toCameraCoordinatesWithLensTable({
            depth, x: pixelX, y: pixelY, lensTable: mill_sensor_M12B3713IRM12_lens_table_1.millSensorM12B3713IRM12LensTable
        });
    }
    static computeStats(array) {
        let usablePixels = 0;
        let errorPixels = 0;
        const emptyPixels = 0;
        for (let y = 0; y < Tofcam660HDF5Image.HEIGHT; y++) {
            for (let x = 0; x < Tofcam660HDF5Image.WIDTH; x++) {
                if (Tofcam660HDF5Image.getRawFromArray(array, x, y).depthValid) {
                    usablePixels++;
                }
                else {
                    errorPixels++;
                }
            }
        }
        return { usablePixels, errorPixels, emptyPixels };
    }
    static getRawFromArray(array, x, y) {
        const depth = array.get(0, y, x);
        const amplitude = array.get(1, y, x);
        const distanceValid = depth >= Tofcam660HDF5Image.VALID_DISTANCE_RANGE[0] && depth <= Tofcam660HDF5Image.VALID_DISTANCE_RANGE[1];
        const amplitudeValid = amplitude >= Tofcam660HDF5Image.VALID_AMPLITUDE_RANGE[0] && amplitude <= Tofcam660HDF5Image.VALID_AMPLITUDE_RANGE[1];
        const depthValid = distanceValid && amplitudeValid;
        return { depth, amplitude, depthValid };
    }
}
exports.Tofcam660HDF5Image = Tofcam660HDF5Image;
